import React, { useState } from 'react'
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons'
import InfluencerRowStats from '../../../../../components/ProjectManager/Campaign/CampaignPageParts/ReportParts/InfluencerOverviewParts/InfluencerRowStats'
import InfluencerDetails from '../../../../../components/ProjectManager/Campaign/CampaignPageParts/ReportParts/InfluencerOverviewParts/InfluencerDetails'
import ReportInfluencerPerformance from '../../../../../models/ReportInfluencerPerformance'

export default function InfluencerOverview({ selectedScenario, influencerPerformances }) {
  const [expandInfs, setExpandInfs] = useState(true)
  const [expandInfDetails, setExpandInfDetails] = useState(true)

  const actionsByInfluencer = selectedScenario?.actions
    .filter(action => action.action_type !== 'non_media_item')
    .reduce((object, action) => {
      if(!object[action.influencer_id]) object[action.influencer_id] = []
      object[action.influencer_id].push(action)
      return object
    }, {})

  const actionGroups = actionsByInfluencer && Object.values(actionsByInfluencer)

  const getPerformance = (influencerId) => {
    const existingPerformance = influencerPerformances.find(performance => performance.influencer_id === influencerId)
    if (existingPerformance) {
      return existingPerformance
    } else {
      return new ReportInfluencerPerformance({
        influencer_id: influencerId,
        performance: null
      })
    }
  }

  return (
    <div className="bg-white dark:bg-rb-dark-mode border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter rounded-2xl p-4">
      <h1 className='font-bold text-xl py-2 dark:text-white'>Influencer Overview</h1>
      <div className="flex justify-between items-center mb-8">
        <p className="font-bold text-md dark:text-white">Influencer summary</p>
        {expandInfs ? <ChevronDown onClick={() => setExpandInfs(false)} className="dark:text-white" /> : <ChevronUp onClick={() => setExpandInfs(true)} className="dark:text-white" />}
      </div>
      {expandInfs && (
        <>
          <div className="overflow-x-auto pb-4">
            <table className="min-w-full border-separate border-spacing-0">
              <thead>
                <tr className="bg-[#F0F5F4] dark:bg-rb-dark-mode-lighter">
                  <th className="text-sm font-normal text-left border-1 border-border-primary dark:border-rb-dark-mode-lighter px-4 py-2 rounded-tl-lg sticky left-0 z-10 bg-[#F0F5F4] dark:bg-rb-dark-mode-lighter dark:text-white">Name</th>
                  <th className="text-sm font-normal text-left border-1 border-border-primary dark:border-rb-dark-mode-lighter px-4 py-2 dark:text-white">Performance</th>
                  <th className="text-sm font-normal text-left border-1 border-border-primary dark:border-rb-dark-mode-lighter px-4 py-2 dark:text-white">Follower</th>
                  <th className="text-sm font-normal text-left border-1 border-border-primary dark:border-rb-dark-mode-lighter px-4 py-2 dark:text-white">Reach</th>
                  <th className="text-sm font-normal text-left border-1 border-border-primary dark:border-rb-dark-mode-lighter px-4 py-2 dark:text-white">Impressions</th>
                  <th className="text-sm font-normal text-left border-1 border-border-primary dark:border-rb-dark-mode-lighter px-4 py-2 dark:text-white">Likes</th>
                  <th className="text-sm font-normal text-left border-1 border-border-primary dark:border-rb-dark-mode-lighter px-4 py-2 dark:text-white">Comments</th>
                  <th className="text-sm font-normal text-left border-1 border-border-primary dark:border-rb-dark-mode-lighter px-4 py-2 dark:text-white">Saves</th>
                  <th className="text-sm font-normal text-left border-1 border-border-primary dark:border-rb-dark-mode-lighter px-4 py-2 dark:text-white">Eng. Rate</th>
                  <th className="text-sm font-normal text-left border-1 border-border-primary dark:border-rb-dark-mode-lighter px-4 py-2 dark:text-white">Price</th>
                  <th className="text-sm font-normal text-left border-1 border-border-primary dark:border-rb-dark-mode-lighter px-4 py-2 dark:text-white">CPM Follower</th>
                  <th className="text-sm font-normal text-left border-1 border-border-primary dark:border-rb-dark-mode-lighter px-4 py-2 dark:text-white">CPM Impression</th>
                  <th className="text-sm font-normal text-left border-1 border-border-primary dark:border-rb-dark-mode-lighter px-4 py-2 rounded-tr-lg min-w-[100px] dark:text-white">Cost/Eng Rate</th>
                </tr>
              </thead>
              <tbody>
                {actionGroups?.map((actionGroup) => (
                  <InfluencerRowStats
                    key={actionGroup[0].influencer_id}
                    infActions={actionGroup}
                    performance={getPerformance(actionGroup[0].influencer_id)}
                  />
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
      <div className="flex justify-between items-center my-8">
        <p className="font-bold text-md dark:text-white">Influencer details</p>
        {expandInfDetails ? <ChevronDown onClick={() => setExpandInfDetails(false)} className="dark:text-white" /> : <ChevronUp onClick={() => setExpandInfDetails(true)} className="dark:text-white" />}
      </div>
      {expandInfDetails && (
        <>
          {
            actionGroups?.map((actionGroup) => (
              <InfluencerDetails
                key={actionGroup[0].influencer_id}
                infActions={actionGroup}
                performance={influencerPerformances.find(performance => performance.influencer_id === actionGroup[0].influencer_id)}
              />
            ))
          }
        </>
      )}
    </div>
  )
}